import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';
import {CalculationField} from '../../interfaces/CalculationField';
import {CalculationVariable} from './calculation-variable.interface';
import {EFieldType} from '../../enums/e-field-type.enum';
import {CalculationResult} from './calculation-result.interface';

@Injectable()
export class CalculationService {
  private headers = new Headers({'Content-Type': 'application/json'});
  private calculationUrl = 'calculation';
  private calculateUrl = 'calculate';

  constructor(private http: AuthHttp) {
  }


  public getFields(parentId: number) {
    const url = `${environment.baseUrl}${this.calculationUrl}/${parentId}`;
    return this.http
      .get(url, {headers: this.headers})
      .toPromise()
      .then(response => {
        return response.json() as CalculationField[];
      })
      .catch(this.handleError);
  }

  public create(parentId: number, calculationField: CalculationField) {
    const url = `${environment.baseUrl}${this.calculationUrl}/${parentId}`;
    return this.http
      .post(url, JSON.stringify(calculationField), {headers: this.headers})
      .toPromise()
      .then(response => {
        return response.json() as CalculationField[];
      })
      .catch(this.handleError);
  }


  public delete(id: number): Promise<void> {
    const url = `${environment.baseUrl}${this.calculationUrl}/${id}`;
    return this.http
      .delete(url, {headers: this.headers})
      .toPromise()
      .then(() => null)
      .catch(this.handleError);
  }


  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  public runCalculate(formula: string, variables: CalculationVariable[], $type: EFieldType): Promise<CalculationResult> {
    const encodedVariables = encodeURIComponent(JSON.stringify(variables));
    const encodedFormula = encodeURIComponent(formula);
    const url = `${environment.baseUrl}${this.calculateUrl}` +
      `?calculation=${encodedFormula}&variables=${encodedVariables}&type=${$type}`;
    return this.http.get(url, {headers: this.headers}).map(res => res.json()).toPromise()
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/services/calculation/calculation.service.ts